import { events } from "@constants/tracking";
import type { SlideData } from "@memorang/ui/components/SlideShow";
import SlideShowRendererBase from "@memorang/ui/components/SlideShowRenderer";
import { trackCustomEvent } from "analytics";
import { useLocalSearchParams } from "expo-router";
import { useCallback } from "react";
import useAIFeedbackStore from "../hooks/useAIFeedbackStore";

const SlideShowRenderer = ({
	slideshowData,
	itemId,
}: {
	slideshowData?: SlideData[];
	itemId?: number;
}) => {
	const updateSlideshowDurationInSeconds = useAIFeedbackStore(
		(state) => state.updateSlideshowDurationInSeconds,
	);
	const { id: sessionId } = useLocalSearchParams<{ id: string }>();

	const handleTracking = useCallback(
		(uri: string, type: "ended" | "started" | "paused") => {
			const getEventName = () => {
				switch (type) {
					case "ended":
						return events.sessionItemAudioEnded;
					case "started":
						return events.sessionItemAudioStarted;
					case "paused":
						return events.sessionItemAudioPaused;
					default:
						return "";
				}
			};
			trackCustomEvent({
				eventName: getEventName(),
				uri,
				type,
				itemId,
				sessionId,
			});
		},
		[itemId, sessionId],
	);

	return (
		<SlideShowRendererBase
			slideshowData={slideshowData}
			itemId={itemId}
			updateSlideshowDurationInSeconds={updateSlideshowDurationInSeconds}
			handleTracking={handleTracking}
		/>
	);
};

export default SlideShowRenderer;
